<template>
  <footer class="footer-wrapper">
    <div class="container">
      <div class="text-center"> 
        <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/footer_logo.png" alt="Mission Tiger Logo" class="img-fluid mb-3" style="max-width: 300px;" />
      </div>
      <div class="text-center social-media-icons">
        <ul class="list-inline">
          <li class="list-inline-item">
            <a href="https://www.facebook.com/frostedflakes/" title="" target="_blank">
              <span class="icon icon-social-facebook">
                <img data-icon-name="social-facebook" src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/social-facebook.png" alt="social-facebook" loading="lazy">
              </span>
            </a>
          </li>
          <li class="list-inline-item mx-3">
            <a href="https://www.instagram.com/kelloggsfrostedflakes/?hl=en" title="" target="_blank">
              <span class="icon icon-social-instagram">
                <img data-icon-name="social-instagram" src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/social-instagram.png" alt="social-instagram" loading="lazy">
              </span>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="https://www.youtube.com/channel/UCTOHNAHQ0E7wNwYVcPq4xZA" title="" target="_blank">
              <span class="icon icon-social-youtube">
                <img data-icon-name="social-youtube" src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/social-youtube.png" alt="social-youtube" loading="lazy">
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div> 
    <p class="copyright-block text-center mb-0 mt-5">
      © {{ new Date().getFullYear() }} {{ $t('Footer.AllrightReserved') }}
    </p>
    <div class="navbar p-0">
        <div class="col">
          <ul class="list-inline mb-0 text-center" id="footer-nav">
            <li class="list-inline-item" v-html="$t('Footer.T&CLink')"></li>
            <li class="list-inline-item" v-html="$t('Footer.CookiePreference')"></li>
            <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')"></li>
            <li class="list-inline-item" v-html="$t('Footer.SnippPrivacyPolicyLink')"></li>
            <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')"></li>
            <li class="list-inline-item" v-html="$t('Footer.DNSLink')"></li>
            <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">
            </li>
          </ul>
        </div>
    </div>
    <div class="short-rules mt-5 text-center">
      <div class="container">
        <span v-html="$t('Footer.legalrules')"></span>
      </div>
    </div>
  </footer>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import { loadLocaleMessages } from '@/main.js';
export default {
  setup() {
    const { locale } = useI18n();
    const currentLang = ref(locale.value);

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      await loadLocaleMessages(lang);
      locale.value = lang;
      localStorage.setItem('locale', lang);
      currentLang.value = lang;
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    return { currentLang, changeLanguage };
  },
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  }  
};
</script>


